import setStatus from './set-status';

export default {
  setStatus,
};
